<template lang="html">
  <div class="">
    <transition-group name="list" tag="p">
      <div v-for="task in timer_tasks" :key="task.id">
        <timer_element :task="task" v-on="$listeners"/>
      </div>
  </transition-group>
  </div>

</template>

<script>
import timer_element from './timer_element';

export default {
  props:["timer_tasks"],
  components: {
    timer_element
  }
}
</script>

<style lang="css" scoped>
</style>
